import React from 'react';

import './card.css';

import { classnames } from '../../../utils/classnames'

export function Button({ label, className, children, ...rest }) {
	return (
		<button
			className={classnames('wz-neo-button-2', className)}
			{...rest}
		>
			{label}
			{children}
		</button>
	);
}

export function Card({ children, disabled, className, title, subtitle, ...rest }) {
	return (
		<div className={classnames('wz-neo-card', className, { disabled })} {...rest}>
			{title && <div className={classnames('wz-neo-card__header')}>
				<h3 className='wz-neo-card__title'>{title}</h3>
				{subtitle && <p className='wz-neo-card__subtitle'>{subtitle}</p>}
			</div>}
			{ children }
		</div>
	);
}

